import * as THREE from "three";

const meshRegistry = new Map<string, THREE.Object3D>();

export function registerMesh(id: string, mesh: THREE.Object3D | null) {
  if (mesh) {
    meshRegistry.set(id, mesh);
  } else {
    meshRegistry.delete(id);
  }
}

export function getMesh(id: string): THREE.Object3D | undefined {
  return meshRegistry.get(id);
}

/** Find the object ID that owns a given mesh (reverse lookup). */
export function getOwnerId(mesh: THREE.Object3D): string | undefined {
  for (const [id, m] of meshRegistry) {
    if (m === mesh) return id;
  }
  return undefined;
}

/** Compute the world-space bounding box of a registered mesh.
 *  Returns { size: [w,h,d], center: [x,y,z], min: [x,y,z], max: [x,y,z] }
 *  or null if the mesh is not found. */
export function getBoundingBox(id: string): {
  size: [number, number, number];
  center: [number, number, number];
  min: [number, number, number];
  max: [number, number, number];
} | null {
  const mesh = meshRegistry.get(id);
  if (!mesh) return null;

  // Update world matrix so the box is accurate
  mesh.updateWorldMatrix(true, true);

  const box = new THREE.Box3().setFromObject(mesh);
  const size = new THREE.Vector3();
  const center = new THREE.Vector3();
  box.getSize(size);
  box.getCenter(center);

  return {
    size: [size.x, size.y, size.z],
    center: [center.x, center.y, center.z],
    min: [box.min.x, box.min.y, box.min.z],
    max: [box.max.x, box.max.y, box.max.z],
  };
}
